import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-Alerts',
    templateUrl: './Alerts.component.html',
    styleUrls: ['./Alerts.component.css'],
    standalone: false
})
export class AlertComponent {
  @Input() __sMessageTitle: any;
  @Input() __sMessage: any;
  @Input() __iPopupHeight: any = 'auto';
  @Input() __sMessageType: any;
  @Input() __bConfirmationVisible: boolean = false;
  @Output() __closeAlert = new EventEmitter();//FB44260-Pawan Prajapati
  __sCSSClass: string = '';
  constructor() {

  }
  // fires on post view renders
  ngAfterViewInit(): void {
  }

  // fires on initialization
  ngOnInit() {
    this.__sCSSClass = (this.__sMessageType == 'Success' ? 'popupSuccess' : (this.__sMessageType == 'Information' ? 'popupInformation' : (this.__sMessageType == 'Warning' ? 'popupWarning' : (this.__sMessageType == 'Error' ? 'popupError' : ''))));

  }

  Confirmation_Click() {
    this.__bConfirmationVisible = false;
    this.__closeAlert.emit();//FB44260-Pawan Prajapati
  }
}
